import React, { Component } from "react";
import jsonData from "../JasonData/E5TableData.json";
import InquiryPopup from "./InquiryForm";
import PDFJSON from "../JasonData/PDFURL.json";
import { Link } from "react-router-dom";

const proimage = require("../../images/product/E5/Melting Furnace E5 Big.webp");
const proimage1 = require("../../images/product/E5/MeltingFurnaceHotpot.webp");
const proimage2 = require("../../images/product/E5/Referance-Layout.webp");
const imgIcon = require("../../images/product/icon-1.png");

const handleDownload = () => {
  const link = document.createElement("a");
  link.href = process.env.PUBLIC_URL + PDFJSON.G25PDFURL; // Replace with the actual path to your PDF file
  link.download = "E5Catalogue.pdf"; // Name of the downloaded file
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
};

class E5Details extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isPopupOpen: false,
    };
  }

  openPopup = () => {
    this.setState({ isPopupOpen: true });
  };

  closePopup = () => {
    this.setState({ isPopupOpen: false });
  };

  render() {
    return (
      <>
        <div className="page-content bg-white">
          <div className="content-block">
            <div className="container">
              <div className="row">
                <div className="col-md-4 col-lg-4 col-xl-4">
                  <label className="gradiant-label">
                  MELTING FURNACE E-10/E-20
                  </label>
                  <div className="card-body card-body-style">
                    <h4 style={{ textAlign: "center" }}>
                      Standard Power Rating
                    </h4>
                    <hr style={{ border: "2px solid black" }} />
                    <h5 style={{ textAlign: "center" }}>50KW/75KW/100KW/125KW</h5>
                    <h5 style={{ textAlign: "center" }}>1000Hz/3000Hz</h5>
                  </div>
                  <div className="card-body card-body-style">
                    <h4 style={{ textAlign: "center" }}>
                    HOT POT SIZE
                    </h4>
                    <hr style={{ border: "2px solid black" }} />
                    <h5 className="card-text" style={{ textAlign: "center" }}>50KG/75KG/100KG/150KG/200KG/300KG</h5>
                  </div>

                  <label className="gradiant-label">APPLICATION</label>
                  <div className="card-body card-body-style">
                    <div>
                      <i className="fa fa-gear mx-2"></i>
                      <span className="card-text">Foundry/Lost wax casting</span>
                    </div>
                    
                    <div>
                      <i className="fa fa-gear mx-2 my-3"></i>
                      <span className="card-text">Silver/Iron/Copper/Brass</span>
                      <span className="card-text">Steel/Aluminum</span>
                    </div>
                    
                  </div>
                </div>

                <div className="col-md-8" style={{ textAlign: "center" }}>
                  <div className="blog-post blog-lg blog-rounded ">
                    <div className="">
                      <img className="img-fluid" src={proimage} alt="image1" />
                    </div>
                    <button
                      className="site-button black m-r5 my-2"
                      type="button"
                      onClick={this.openPopup}
                    >
                      <span className="site-button-inr">
                        Inquiry <i className="ti-email"></i>
                      </span>
                    </button>
                    <InquiryPopup
                      className="inq-pop"
                      show={this.state.isPopupOpen}
                      onClose={this.closePopup}
                    />

                    <button
                      className="site-button black m-r5"
                      type="button"
                      onClick={handleDownload}
                    >
                      <span className="site-button-inr">
                        Catalogue <i className="ti-download"></i>
                      </span>
                    </button>
                  </div>
                  <div></div>
                </div>
              </div>
            </div>
          </div>

          {/* start */}

          <div className="page-content " style={{ background: "#f4f4f4" }}>
                    <div className="content-block">                        
                    <div className="section-full content-inner video-section">
                            <div className="container">
                                <div className="section-content">
                                    <div className="row d-flex">
                                        <div className="col-lg-6 col-md-12 m-b30">
                                            <div className="video-bx">
                                                <img src={proimage1} alt="Signature" />
                                            </div>
                                        </div>
                                        <div className="col-lg-6 col-md-12 m-b30 align-self-center video-infobx">
                                          <table>
                                              <thead>
                                                <tr>
                                                  <th>Size</th>
                                                  <th>Brass @950°C (KG/HR)</th>
                                                  <th>Copper @1100°C (KG/HR)</th>
                                                  <th>Steel @1650°C (KG/HR)</th>
                                                  <th>Iron @1485°C (KG/HR)</th>
                                                </tr>
                                              </thead>
                                              <tbody>
                                                {jsonData.map((data) => (
                                                  <tr key={data.id}>
                                                    <td>{data.size}</td>
                                                    <td>{data.brass}</td>
                                                    <td>{data.copper}</td>
                                                    <td>{data.steel}</td>
                                                    <td>{data.iron}</td>
                                                  </tr>
                                                ))}
                                              </tbody>
                                          </table>                                             
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
          </div>

          {/* end */}

         
          <div className="page-content bg-white">
                    <div className="content-block">                        
                    <div className="section-full content-inner video-section">
                            <div className="container">
                                <div className="section-content">
                                    <div className="row d-flex">
                                        <div className="col-lg-6 col-md-12 m-b30">
                                        <img src={imgIcon} alt="icon-1" />
                                          <span className="card-text mx-3" style={{ fontSize: "28px" }}>
                                          3D Proposed Layout
                                          </span>
                                          <div className="dlab-divider divider-2px bg-red" />

                                          <img className="img-fluid" src={proimage2} alt="image1" />
                                        </div>
                                        <div className="col-lg-6 col-md-12 m-b30  video-infobx">
                                        <img src={imgIcon} alt="icon-1" />
                                          <span className="card-text mx-3" style={{ fontSize: "24px" }}>
                                            Related Products
                                          </span>
                                          <div className="dlab-divider divider-2px bg-red" />
                                          <div className="row">
                                            <div className="post card-container col-lg-6 col-md-6 col-sm-12">
                                              <Link to="/e70" class="site-button outline outline-2 black m-r15" type="button" style={{ width: "200px" }}
                                              >E-70</Link>
                                              <Link to="/e5" class="site-button outline outline-2 black m-r15 my-4" type="button" style={{ width: "200px" }}
                                              >E-5 </Link>
                                              <Link to="/hotpot" class="site-button outline outline-2 black m-r15 " type="button" style={{ width: "200px" }}
                                              >Hot Pot </Link>
                                            </div>
                                            <div className="post card-container col-lg-6 col-md-6 col-sm-12">
                                              <Link to="/e50" class="site-button outline outline-2 black m-r15" type="button" style={{ width: "200px" }}
                                              > E-50 </Link>
                                              <Link to="/e30" class="site-button outline outline-2 black m-r15 my-4" type="button" style={{ width: "200px" }}
                                              > E-30 </Link>
                                              <Link to="/spares" class="site-button outline outline-2 black m-r15 " type="button" style={{ width: "200px" }}
                                              >Spares </Link>
                                            </div>
                                          </div>                                          
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
          </div>

          
        </div>
      </>
    );
  }
}
export default E5Details;
